// @flow

import React from 'react';
import Icon from './Icon';

type Props = {
  span?: boolean,
  paragraph?: boolean,
  h1?: boolean,
  h2?: boolean,
  h3?: boolean,
  h4?: boolean,
  code?: boolean,
  tag?: boolean,
  link?: boolean,
  altLink?: boolean,
  italic?: boolean,
  small?: boolean,
  dottedUnderline?: boolean,
  children?: any,
  align?: string, // left, right, center
  className?: string,
  hasSubtitle?: boolean,
  truncated?: boolean,
  icon?: string, // see icons.css for options
  iconClassName?: string,
  href?: string,
  chartValues?: string,
  chartLabel?: string,
  chartTitle?: string,
  uppercase? : boolean,
  lowercase?: boolean,
  bold?: boolean,
  iconSize?: string, // x-small, medium, large, x-large, see icons.css for options
  color?: string, // grey, grey-40, light, light--purple, default color is dark,
  style?: {}
}

const Text = ({ align, className, href, hasSubtitle, icon, iconSize, iconClassName,
  truncated, span, tag, link, altLink, italic, dottedUnderline, paragraph, h1, h2, h3, h4, children, uppercase,
  lowercase, small, chartValues, chartLabel, color, bold, chartTitle, code, style }: Props) => {
  // all the modifiers
  const classOptions = ` 
    ${className}
    ${align ? `is-${align}` : 'is-left'}
    ${color ? `is-${color}` : ''}
    ${italic ? 'is-italic' : ''}
    ${dottedUnderline ? 'is-dotted-underline' : ''}
    ${bold ? 'is-bold is-grey-30' : ''}
    ${hasSubtitle ? 'has-subtitle' : ''}
    ${icon ? 'has-icon' : ''}
    ${uppercase ? 'is-uppercase' : ''}
    ${truncated ? 'is-truncated' : ''}
    ${chartValues ? 'type-chart__values' : ''}
    ${chartLabel ? 'type-chart__label' : ''}
    ${link ? `type-link ${lowercase ? '' : 'is-uppercase'}` : ''}
    ${altLink ? 'type-alt-link' : ''}
    ${tag ? `type-tag ${lowercase ? '' : 'is-uppercase'}` : ''}
  `;

  // options for the icon
  const iconOptions = <Icon name={icon} size={iconSize} className={iconClassName} />;
  return (
    <React.Fragment>
      {paragraph && <div className={`type-paragraph ${classOptions}`}>{icon && iconOptions}{children}</div>}
      {h1 && <h1 className={`type-h1 ${classOptions}`}>{icon && iconOptions}{children}</h1>}
      {h2 && <h2 className={`type-h2 ${classOptions}`}>{icon && iconOptions}{children}</h2>}
      {h3 && <h3 className={`type-h3 ${!lowercase ? 'is-uppercase' : ''} ${classOptions}`}>
        {icon && iconOptions}{children}
      </h3>}
      {code && <code className={`code ${classOptions}`}>{icon && iconOptions}{children}</code>}
      {span
        && <span style={style} className={`${classOptions}`}>{icon && iconOptions}{children}</span>}
      {link
        && <a href={href} className={`type-link ${classOptions}`}>{icon && iconOptions}{children}</a>}
      {altLink
        && <a href={href} className={`type-alt-link ${classOptions}`}>{icon && iconOptions}{children}</a>}
      {tag
        && <span className={`type-tag ${classOptions}`}>{icon && iconOptions}{children}</span>}
      {(h4 || chartTitle)
        && <span className={`type-chart__title is-uppercase ${classOptions}`}>{icon && iconOptions}{children}</span>}
      {small && <div style={style} className={`type-small ${classOptions}`}>{icon && iconOptions}{children}</div>}
      {chartValues
        && <span className={`type-chart__values ${classOptions}`}>{icon && iconOptions}{children}</span>}
      {chartLabel
        && <span className={`type-chart__label is-uppercase ${classOptions}`}>{icon && iconOptions}{children}</span>}
    </React.Fragment>
  );
};

export default Text;


// WEBPACK FOOTER //
// ./src/components/shared/Typography.js